<complex-list-item [item]="listItem" (onMenuItemClick)="handleMenuItemClick($event)">
    <div class="pt-2">
        <key-value [key]="'mapserver.layerslabel' | translate">
            <div class="d-flex flex-column w-100 align-self-center">
                <lumi-select *ngIf="mapLayers?.length > 0" class="ml-auto mr-1 w-100"
                             [options]="mapLayers"
                             [selectedOptions]="selectedMapLayers"
                             [showOptionFilter]="mapLayers?.length > 10"
                             [disabled]="!canEditServerSettings()"
                             [readonly]="!canEditServerSettings()"
                             (onOptionsSelect)="handleOptionSelect($event)"
                             [multi]="true">
                </lumi-select>
            </div>
        </key-value>
        <key-value *ngIf="isWfsServer()" [key]="'Output Format'" class="mt-2">
            <div class="d-flex flex-column w-100 align-self-center">
                <lumi-select class="ml-auto mr-1 w-100"
                             [options]="outputFormatOptions"
                             [selectedOptions]="selectedOutputFormat"
                             [disabled]="!canEditServerSettings()"
                             [readonly]="!canEditServerSettings()"
                             (onOptionsSelect)="handleOutputFormatSelect($event)"
                             [multi]="false">
                </lumi-select>
            </div>
        </key-value>
        <key-value *ngIf="isWfsServer()" [key]="'Expected CRS / SRS'" class="mt-2">
            <div class="d-flex flex-column w-100 align-self-center">
                <lumi-select class="ml-auto mr-1 w-100"
                             [options]="expectedCRSOptions"
                             [selectedOptions]="selectedExpectedCRS"
                             [disabled]="!canEditServerSettings()"
                             [readonly]="!canEditServerSettings()"
                             (onOptionsSelect)="handleExpectedCRSSelect($event)"
                             [multi]="false">
                </lumi-select>
            </div>
        </key-value>
        <div *ngIf="isWfsServer()" class="d-flex justify-content-end mt-2">
            <small class="text-muted">{{ 'mapserver.saveAppliesToBoth' | translate }}</small>
        </div>
        <div class="d-flex justify-content-end mt-2">
            <lumi-button (onClick)="handleClickSave()"
                         [size]="'small'"
                         [icon]="'save'"
                         [rank]="'tertiary'"
                         [disabled]="!canEditServerSettings()"
                         [title]="getSaveTitle()">
            </lumi-button>
        </div>
        <div class="form-attachment-loader mt-2 w-100 {{isLoading || isLoadingError?'':'d-none'}}" style="margin-bottom: -0.5rem">
            <div class="progress">
                <div *ngIf="isLoading" class="indeterminate"></div>
            </div>
        </div>
        <div class="d-flex align-items-center" style="margin-left: -1rem;">
            <i *ngIf="!isLoadingError && serverSettings.disabled" class="material-icons">cloud_off</i>
            <p *ngIf="!isLoadingError && serverSettings.disabled">{{'mapserver.disabled' | translate}}</p>
            <i *ngIf="isLoadingError" class="material-icons" style="color: #ff3333">warning</i>
            <p *ngIf="isLoadingError">{{this.errorMessage}}</p>
        </div>
    </div>
</complex-list-item>
